(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('tableauEffectifAnneeConcerneeSecuriteCtrl', tableauEffectifAnneeConcerneeSecuriteCtrl);

    tableauEffectifAnneeConcerneeSecuriteCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function tableauEffectifAnneeConcerneeSecuriteCtrl ($scope, $state, ParseLinks, AlertService) {

    }
})();
